export function resolveOverallBudget(
    demolitionBudget: number | null | undefined,
    constructionBudget: number | null | undefined,
): number | null {
    if (Number.isNaN(demolitionBudget) || demolitionBudget === undefined) {
        demolitionBudget = null;
    }
    if (Number.isNaN(constructionBudget) || constructionBudget === undefined) {
        constructionBudget = null;
    }
    if (demolitionBudget == null && constructionBudget == null) {
        return null;
    }
    return Number(demolitionBudget) + Number(constructionBudget);
}

export function resolveCostPerUnitSurface(
    overallBudget: number | null | undefined,
    floorSurface: number | null | undefined,
): number | null {
    if (!floorSurface || overallBudget == null) {
        return null;
    }
    return overallBudget / floorSurface;
}
